import { useLoginPoolSidebarItems } from '_/components/LoginPools/useLoginPoolSidebarItems';
import { useSidebar, CONTEXT_DEPTH } from '_/contexts/LayoutContext';
import { LoginPoolProvider, useLoginPoolContext } from '_/contexts/LoginPoolContext';
import React, { ReactNode, useEffect } from 'react';

interface LoginPoolSectionProps {
  children: ReactNode;
}

/**
 * Sidebar manager that consumes LoginPoolContext
 * Separated from provider to avoid circular dependency
 */
function LoginPoolSidebarManager({ children }: LoginPoolSectionProps) {
  const { selectedLoginPoolSlug } = useLoginPoolContext();
  const { setSidebarItems, registerContext, unregisterContext } = useSidebar();
  const sidebarItems = useLoginPoolSidebarItems();

  useEffect(() => {
    registerContext(CONTEXT_DEPTH.LOGIN_POOL);
    return () => {
      unregisterContext(CONTEXT_DEPTH.LOGIN_POOL);
    };
  }, [registerContext, unregisterContext]);

  useEffect(() => {
    if (selectedLoginPoolSlug && selectedLoginPoolSlug !== '_new' && sidebarItems.length > 0) {
      setSidebarItems(sidebarItems, CONTEXT_DEPTH.LOGIN_POOL);
    }
  }, [setSidebarItems, sidebarItems, selectedLoginPoolSlug]);

  return <>{children}</>;
}

/**
 * LoginPoolSection - Wrapper for login pool-level pages
 * Combines provider and sidebar manager
 */
function LoginPoolSection({ children }: LoginPoolSectionProps) {
  return (
    <LoginPoolProvider>
      <LoginPoolSidebarManager>{children}</LoginPoolSidebarManager>
    </LoginPoolProvider>
  );
}

export default LoginPoolSection;
